var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssimetriaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 5.39062C11 5.79688 10.5312 6 10 6C9.46875 6 9 5.79688 8.59375 5.39062C8.1875 4.98438 7.98438 4.51562 7.98438 3.98438C7.98438 3.45312 8.1875 3 8.59375 2.625C9 2.21875 9.46875 2.01562 10 2.01562C10.5312 2.01562 11 2.21875 11.4062 2.625C11.8125 3 12.0156 3.45312 12.0156 3.98438C12.0156 4.51562 11.8125 4.98438 11.4062 5.39062ZM18.4844 6L19 8.01562C17.4375 8.45312 15.4375 8.78125 13 9V21.9844H10.9844V15.9844H9.01562V21.9844H7V9C4.5625 8.78125 2.5625 8.45312 1 8.01562L1.51562 6C3.95312 6.65625 6.78125 6.98438 10 6.98438C13.2188 6.98438 16.0469 6.65625 18.4844 6Z",
    fill: "#797D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.9688H10.9844V21.9688H13V8.98438C15.4375 8.76562 17.4375 8.4375 19 8L18.4844 5.98438C16.0469 6.64062 13.2188 6.96875 10 6.96875V15.9688ZM10 5.98438C10.5312 5.98438 11 5.78125 11.4062 5.375C11.8125 4.96875 12.0156 4.5 12.0156 3.96875C12.0156 3.4375 11.8125 2.98438 11.4062 2.60938C11 2.20312 10.5312 2 10 2V5.98438Z",
    fill: "#00D084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssimetriaIcon);
export default __webpack_public_path__ + "static/media/assimetria_icon.b6f021d9a0b7ca003784075dab37ad94.svg";
export { ForwardRef as ReactComponent };